import classnames from 'classnames'
import React, { FC } from 'react'

import SVGLiveReload from './LiveReload.svg'
import SVGReload from './Reload.svg'
import './LiveReloadButton.scss'

interface LiveReloadButtonProps {
  addedCallbacksCount: number
  addedRedirectsCount: number
  onClick: React.MouseEventHandler<HTMLButtonElement>
  className?: string
}

export const LiveReloadButton: FC<LiveReloadButtonProps> = ({ addedCallbacksCount, addedRedirectsCount, onClick, className }) => (
  <div
    className={classnames(
      'live-reload-button',
      {
        'live-reload-button--open': addedCallbacksCount + addedRedirectsCount > 0,
      },
      className
    )}
  >
    <button className="live-reload-button__button" onClick={onClick} type="button">
      <span className="live-reload-button__label live-reload-button__left">
        <SVGLiveReload width="24px" height="24px" />
        {addedCallbacksCount + addedRedirectsCount === 1
          ? '1 neue Anfrage'
          : `${addedCallbacksCount + addedRedirectsCount} neue Anfragen`}
        {`- ${addedCallbacksCount} via Rückruf, ${addedRedirectsCount} via Weiterleitung`}
      </span>
      <span className="live-reload-button__label live-reload-button__right">
        <SVGReload width="22px" height="22px" />
        Zum Aktualisieren klicken
      </span>
    </button>
  </div>
)
